<style>
  @import url('https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css');
  @import url('https://fonts.googleapis.com/css?family=Material+Icons');
  @import url('https://unpkg.com/vue-form-wizard/dist/vue-form-wizard.min.css');
</style>

<template>
  <div class="app-base-container">
    <v-app-bar app>
      <v-container>
        <v-row>
          <v-col class="nonothing">
            <a href="https://prosas.com.br/dashboards/polls">
              <img alt="Logo Prosas" class="logoprosas" src="https://prosas.com.br/assets/white-logotipo-42895b326e079e3497ad9a9de07aa46602ff55827591ea153338b1b62cd4fab5.png">
            </a>
          </v-col>
          <v-col align="center" class="nonothing">
            <h1 class="titlebar">Painel Gerencial</h1>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-container id="main-container">
      <router-view></router-view>
    </v-container>

    <v-footer class="footer" align="center" justify="center">
      <v-container class="nopadding">
        <v-row class="nonothing">
          <v-col cols="12" class="nopadding">
            <ul class="nonothing menuline">
              <li v-for="(link, index) in footerLinks" :key="index">
                <router-link :to="{path: 'link.routerName'}" :href="link.url"
                    clickable target="_blank" class="white--text">
                  {{ link.name }}
                </router-link>
              </li>
            </ul>
          </v-col>
        </v-row>

        <v-row class="nonothing">
          <v-col cols="12" class="nopadding">
            <div id="social-network">
              <ul class="svgmidia layout-margin layout-row" layout="row" layout-margin="">
                <li flex="30" class="flex-30">
                    <a href="https://www.facebook.com/prosasconecta" target="_blank" rel="noopener">
                        <img alt="Facebook icon" src="https://prosas.com.br/img/redes_sociais/facebook_icon.png">
                    </a>
                </li>
                <li flex="30" class="flex-30">
                    <a href="https://www.instagram.com/prosasconecta/" target="_blank" rel="noopener">
                        <img alt="Instagram icon" src="https://prosas.com.br/img/redes_sociais/instagram_icon.png">

                    </a>
                </li>
                <li flex="30" class="flex-30">
                    <a href="https://www.linkedin.com/company/prosas/" target="_blank" rel="noopener">
                        <img alt="Linkedin icon" src="https://prosas.com.br/img/redes_sociais/linkedin_icon.png">
                    </a>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
import TopMenu from './TopMenu';
export default {
  name: 'BaseLayout',
  components: {
    TopMenu
  },
  data: () => ({
    footerLinks: [{
      name: "SOBRE O PROSAS",
      url: "https://prosas.com.br/sobre",
      routerName: "about"
    }, {
      name: "TERMOS DE USO",
      url: "https://prosas.com.br/termos",
      routerName: "terms"
    }, {
      name: "FUNCIONALIDADES",
      url: "https://prosas.com.br/para-patrocinadores",
      routerName: "functionality"
    }, {
      name: "ALERTA DE EDITAIS",
      url: "https://prosas.com.br/conheca-alerta-editais",
      routerName: "alert"
    }, {
      name: "PARCEIROS",
      url: "https://prosas.com.br/parceiros",
      routerName: "partners"
    }, {
      name: "DEPOIMENTOS",
      url: "https://prosas.com.br/depoimentos",
      routerName: "testimony"
    }, {
      name: "BLOG",
      url: "http://blog.prosas.com.br",
      routerName: "blog"
    }, {
      name: "CONTATO",
      url: "https://prosas.com.br/contatos",
      routerName: "contact"
    }],
    menuLinks: [
      { title: 'INÍCIO' , link: '' , icon: 'home' },
      { title: 'MEU CADASTRO' , link: '' , icon: 'home' },
      { title: 'SAIR' , link: '' , icon: 'home' },
    ],
  }),
  mounted() {
    let vueFormWzd = document.createElement('script');
    vueFormWzd.setAttribute('src', 'https://unpkg.com/vue-form-wizard/dist/vue-form-wizard.js');
    document.head.appendChild(vueFormWzd);
  },
};
</script>

<style scoped>
  h1.titlebar {
    color: #fff;
    opacity: 1;
    line-height: 16px;
    margin: 0;
    padding: 4px 0;
    font-size: 22px;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 400;
  }

  .app-base-container {
    background: #f0f2f2;
  }

  .v-application a {
    color: #20c09e;
    display: inline-block;
  }

  .v-application .accent--text {
    color: #20c09e !important;
    caret-color: #20c09e !important;
  }

  .nonothing {
    margin: 0 !important;
    padding: 0 !important;
  }

  .nopadding {
    padding: 0 !important;
  }

  #main-container {
    height: 100%;
    min-height: calc(100vh - 123px);
    max-width: 1182px;
  }

  @media screen and (min-width: 1440px) {
    #main-container, .container {
        max-width: 1440px !important;
        padding: 0;
    }
  }

  @media (max-width: 1440px) {
    #main-container, .container {
        max-width: 1280px !important;
    }
  }
</style>

<!-- HEADER AND FOOTER CSS -->
<style scoped>
  header {
    background: #445b65 !important;
    border-top: thin solid #fff !important;
    border-bottom: thin solid #fff !important;
    box-shadow: 0px 1px 2px rgb(0 0 0 / 10%) !important;
  }

  img.logoprosas {
    margin-top: 6px;
    width: 70px;
  }

  .footer {
    width: 100%;
    background: #37474f !important;
    margin: 0;
    z-index: 1;
    position: relative;
    border-top: 2px solid #ca1712;
    list-style: outside none none;
    font-family: 'Source Sans Pro', sans-serif;
    color: #4d4c4c !important;
    font-size: 12px !important;
    line-height: 1.42857143 !important;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  ul.menuline {
    border-bottom: thin solid #27363d;
  }

  ul.menuline li:first-child {
    border: none;
  }

  ul.menuline li {
    display: inline-block;
    color: #fff;
    border-left: thin solid #fff;
    line-height: 0px;
    padding: 6px 0;
    margin: 20px 0;
  }

  ul.menuline li a {
    color: #fff;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 0 12px;
    line-height: 12px;
    display: inline-block;
    text-decoration: none;
    background-color: transparent;
    list-style: none;
}

  ul.svgmidia {
    padding: 0;
    margin: 0;
  }

  #social-network {
    max-width: 160px;
    margin: 24px 0 8px;
    display: inline-block;
  }

  .svgmidia li {
    float: left;
    overflow: hidden;
    margin: 0 auto;
    display: table;
    color: #fff;
    border-left: none;
    line-height: 0px;
    padding: 0;
    margin: 0 0 10px;
  }

  .svgmidia li a {
    letter-spacing: 1px;
    padding: 0 10px;
    line-height: 10px;
    display: inline-block;
    cursor: pointer;
    text-decoration: none;
    background-color: transparent;
    list-style: none;
  }

  .svgmidia li a img {
    max-width: 100%;
    vertical-align: middle;
    border: 0;
    height: 24px;
  }
</style>

<!-- SUMMERNOTE TEXT CSS -->
<style>
  .v-card__actions button {
    min-height: 44px;
    margin-bottom: 16px;
    font-size: 12px !important;
    line-height: 44px !important;
    padding: 0 16px !important;
    border-radius: 0;
  }

  .ql-align-left {
      text-align: left;
  }

  .ql-align-center {
      text-align: center;
  }

  .ql-align-right {
    text-align: right;
  }

  .ql-align-justify {
    text-align: justify;
  }

  .ql-size-small {
    font-size: 12px;
  }

  .ql-size-large {
    font-size: 20px;
  }

  .ql-size-huge {
    font-size: 24px;
    font-weight: 900;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/BaseLayout.vue